"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MobileServiceCoverageItem$ = exports.MobileServiceCoverageItem$outboundSchema = exports.MobileServiceCoverageItem$inboundSchema = void 0;
exports.mobileServiceCoverageItemToJSON = mobileServiceCoverageItemToJSON;
exports.mobileServiceCoverageItemFromJSON = mobileServiceCoverageItemFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
const mobileenum_js_1 = require("./mobileenum.js");
/** @internal */
exports.MobileServiceCoverageItem$inboundSchema = z.object({
    data_indoor_4g: z.nullable(mobileenum_js_1.MobileEnum$inboundSchema),
    data_indoor_no_4g: z.nullable(mobileenum_js_1.MobileEnum$inboundSchema),
    data_outdoor_4g: z.nullable(mobileenum_js_1.MobileEnum$inboundSchema),
    data_outdoor_no_4g: z.nullable(mobileenum_js_1.MobileEnum$inboundSchema),
    network: z.nullable(z.string()),
    voice_indoor_4g: z.nullable(mobileenum_js_1.MobileEnum$inboundSchema),
    voice_indoor_no_4g: z.nullable(mobileenum_js_1.MobileEnum$inboundSchema),
    voice_outdoor_4g: z.nullable(mobileenum_js_1.MobileEnum$inboundSchema),
    voice_outdoor_no_4g: z.nullable(mobileenum_js_1.MobileEnum$inboundSchema),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "data_indoor_4g": "dataIndoor4g",
        "data_indoor_no_4g": "dataIndoorNo4g",
        "data_outdoor_4g": "dataOutdoor4g",
        "data_outdoor_no_4g": "dataOutdoorNo4g",
        "voice_indoor_4g": "voiceIndoor4g",
        "voice_indoor_no_4g": "voiceIndoorNo4g",
        "voice_outdoor_4g": "voiceOutdoor4g",
        "voice_outdoor_no_4g": "voiceOutdoorNo4g",
    });
});
/** @internal */
exports.MobileServiceCoverageItem$outboundSchema = z.object({
    dataIndoor4g: z.nullable(mobileenum_js_1.MobileEnum$outboundSchema),
    dataIndoorNo4g: z.nullable(mobileenum_js_1.MobileEnum$outboundSchema),
    dataOutdoor4g: z.nullable(mobileenum_js_1.MobileEnum$outboundSchema),
    dataOutdoorNo4g: z.nullable(mobileenum_js_1.MobileEnum$outboundSchema),
    network: z.nullable(z.string()),
    voiceIndoor4g: z.nullable(mobileenum_js_1.MobileEnum$outboundSchema),
    voiceIndoorNo4g: z.nullable(mobileenum_js_1.MobileEnum$outboundSchema),
    voiceOutdoor4g: z.nullable(mobileenum_js_1.MobileEnum$outboundSchema),
    voiceOutdoorNo4g: z.nullable(mobileenum_js_1.MobileEnum$outboundSchema),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        dataIndoor4g: "data_indoor_4g",
        dataIndoorNo4g: "data_indoor_no_4g",
        dataOutdoor4g: "data_outdoor_4g",
        dataOutdoorNo4g: "data_outdoor_no_4g",
        voiceIndoor4g: "voice_indoor_4g",
        voiceIndoorNo4g: "voice_indoor_no_4g",
        voiceOutdoor4g: "voice_outdoor_4g",
        voiceOutdoorNo4g: "voice_outdoor_no_4g",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var MobileServiceCoverageItem$;
(function (MobileServiceCoverageItem$) {
    /** @deprecated use `MobileServiceCoverageItem$inboundSchema` instead. */
    MobileServiceCoverageItem$.inboundSchema = exports.MobileServiceCoverageItem$inboundSchema;
    /** @deprecated use `MobileServiceCoverageItem$outboundSchema` instead. */
    MobileServiceCoverageItem$.outboundSchema = exports.MobileServiceCoverageItem$outboundSchema;
})(MobileServiceCoverageItem$ || (exports.MobileServiceCoverageItem$ = MobileServiceCoverageItem$ = {}));
function mobileServiceCoverageItemToJSON(mobileServiceCoverageItem) {
    return JSON.stringify(exports.MobileServiceCoverageItem$outboundSchema.parse(mobileServiceCoverageItem));
}
function mobileServiceCoverageItemFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.MobileServiceCoverageItem$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'MobileServiceCoverageItem' from JSON`);
}
//# sourceMappingURL=mobileservicecoverageitem.js.map